import qrcode from 'qrcode-generator';
import { useMemo } from 'react';

/**
 * Il codice QR dell'URL `otpauth://`, per non dover ricopiare a mano il
 * segreto alfanumerico nell'app di autenticazione.
 *
 * `qrcode-generator`: nessuna dipendenza a sua volta, disegna solo la
 * matrice di moduli — l'SVG lo componiamo qui. Nero su bianco fisso, non
 * legato al tema chiaro/scuro: un lettore di codici ha bisogno del contrasto
 * più alto possibile, non di coerenza visiva con la pagina.
 */
export function QrCode({ value, label }: { value: string; label: string }) {
  const cells = useMemo(() => {
    const code = qrcode(0, 'M');
    code.addData(value);
    code.make();
    const count = code.getModuleCount();
    const dark: boolean[][] = [];
    for (let row = 0; row < count; row += 1) {
      dark.push(Array.from({ length: count }, (_, col) => code.isDark(row, col)));
    }
    return { count, dark };
  }, [value]);

  return (
    <svg
      className="qr-code"
      viewBox={`0 0 ${cells.count} ${cells.count}`}
      role="img"
      aria-label={label}
    >
      <rect width={cells.count} height={cells.count} fill="#fff" />
      {cells.dark.map((rowCells, row) =>
        rowCells.map((isDark, col) =>
          isDark ? (
            // biome-ignore lint/suspicious/noArrayIndexKey: la griglia non cambia forma senza cambiare `value`, che rigenera l'intero array.
            <rect key={`${row}-${col}`} x={col} y={row} width={1} height={1} fill="#1a1a1a" />
          ) : null,
        ),
      )}
    </svg>
  );
}
